type CurrencyCode = 'AUD' | 'GBP' | 'EUR' | 'USD'

export const getCurrencyCode = (currencyCodeString: string): CurrencyCode => {
  const supportedCurrencyCodes = ['AUD', 'GBP', 'EUR', 'USD']

  if (supportedCurrencyCodes.includes(currencyCodeString)) {
    return currencyCodeString as CurrencyCode
  }
  return 'GBP'
}
